/**
 * https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#jisuberikeikaikuiki
 * @type {Landslide}
 * 土砂災害警戒区域（地すべり）
 */
module.exports = class Landslide {

  /**
   * Constructor
   */
  constructor() {
  }

  /**
   * To display table
   */
  toDisplay() {
    return [
      {
        alt      : '土砂災害警戒区域の凡例',
        img      : 'https://cdn.jon-api.com/shikaku-map/usage-guide/sediment.png',
        sourceUrl: 'https://disaportal.gsi.go.jp/hazardmap/copyright/opendata.html#jisuberikeikaikuiki'
      }
    ];
  }
}
